import styled from "styled-components";
import {
  colors,
  spacing,
  radius,
  stroke,
  textStyles,
  toCSS
} from "design-system/foundation";
import { breakpoints } from "styles";

export const SubmitContainer = styled.div`
  &,
  & *,
  & *::before,
  & *::after {
    box-sizing: border-box;
  }

  display: flex;
  flex-direction: column;
  gap: ${spacing["4xl"]};
  padding: ${spacing.none} ${spacing["2xl"]};

  @media ${breakpoints.tablet} {
    padding: ${spacing.none};
  }
`;

export const UploadArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: ${spacing["4xl"]};
  gap: ${spacing["7xl"]};
  border: ${stroke.md} dashed ${colors.border.semantic.neutral};
  border-radius: ${radius.lg};
  background-color: ${colors.bg.base.default};

  @media ${breakpoints.tablet} {
    flex-direction: row;
    align-items: center;
  }
`;

export const UploadInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing["4xl"]};
  flex: 1;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: ${radius.lg};
  border: ${stroke.md} solid ${colors.border.semantic.brand};
  padding: ${spacing.md};

  .icon {
    display: flex;
    align-items: center;
    font-size: 28px;
    color: ${colors.icon.state.brandDefault};
  }
`;

export const UploadText = styled.p`
  margin: ${spacing.none};
  ${toCSS(textStyles.body.body3Regular)};
  color: ${colors.text.base.primary};
`;

export const Divider = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${spacing["2xl"]};
`;

export const DividerLine = styled.div`
  flex: 1;
  height: ${stroke.xs};
  background-color: ${colors.border.state.default};
`;

export const DividerText = styled.span`
  ${toCSS(textStyles.body.body3Regular)};
  color: ${colors.text.base.primary};
`;

export const MobileButtonGroup = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: ${spacing["2xl"]};
  width: calc(100% + ${spacing["2xl"]} + ${spacing["2xl"]});
  margin-left: -${spacing["2xl"]};
  padding: ${spacing["2xl"]};
  border-top: ${stroke.xs} solid ${colors.border.state.default};
  background-color: ${colors.bg.base.default};

  @media ${breakpoints.tablet} {
    display: none;
  }
`;
